function swapPairColumns(sim) {
  return {
    ...sim,
    keyword1: sim.keyword2,
    keyword2: sim.keyword1,
    volume1: sim.volume2,
    volume2: sim.volume1,
    formattedAddress1: sim.formattedAddress2,
    formattedAddress2: sim.formattedAddress1,
  };
}

export function buildAllowedKeywordsSet(keywords) {
  return new Set((keywords || []).map(kw => kw.keyword?.toLowerCase() || kw.toLowerCase?.() || ''));
}

export function isPairAllowed(sim, allowedKeywordsSet) {
  if (!allowedKeywordsSet || allowedKeywordsSet.size === 0) return true;
  const keyword1Allowed = allowedKeywordsSet.has(sim.keyword1.toLowerCase());
  const keyword2Allowed = allowedKeywordsSet.has(sim.keyword2.toLowerCase());
  return keyword1Allowed && keyword2Allowed;
}

export function orientSimilarityPairsForColumns(similarities, excludedKeywords1, excludedKeywords2, allowedKeywordsSet) {
  const oriented = [];

  (similarities || []).forEach((sim) => {
    if (!isPairAllowed(sim, allowedKeywordsSet)) return;

    const directColumn1 = !excludedKeywords1.includes(sim.keyword1);
    const directColumn2 = !excludedKeywords2.includes(sim.keyword2);
    if (directColumn1 && directColumn2) {
      oriented.push(sim);
      return;
    }

    const swappedColumn1 = !excludedKeywords1.includes(sim.keyword2);
    const swappedColumn2 = !excludedKeywords2.includes(sim.keyword1);
    if (swappedColumn1 && swappedColumn2) {
      oriented.push(swapPairColumns(sim));
    }
  });

  return oriented;
}
